<template>
	<div id="lock" class="columns">
		<div class="column">
			<div class="card">
				<header class="card-header">
					<section class="card-header-title">Vergrendeling</section>
				</header>
				<header class="card-header" style="background-color:#eeeeee;padding: 12px;">
					<nav class="level">
						<div class="level-left">
							<div class="level-item">
								<b-field>
									<a class="button is-primary" @click="newUser()">
										<b-icon icon="plus-circle-outline"></b-icon>
										<span>Nieuwe Gebruiker</span>
									</a>
								</b-field>
							</div>
							<div class="level-item">
								<b-field>
									<b-select
										icon="school"
										label="school"
										placeholder="Kies een school"
										v-model="selected_school"
									>
										<option :value="0" :key="0">0 - Alle scholen</option>
										<option
											v-for="option in Schools"
											:value="option.id"
											:key="option.id"
										>{{option.schoolnumber}} - {{ option.name }}</option>
									</b-select>
								</b-field>
							</div>
							<div class="level-item">
								<b-field>
									<b-select
										icon="account-circle"
										label="rol"
										placeholder="Kies een rol"
										v-model="selected_role"
									>
										<option :value="0" :key="0">Alle rolen</option>
										<option v-for="option in Roles" :value="option.id" :key="option.id">{{ option.name }}</option>
									</b-select>
								</b-field>
							</div>
							<div class="level-item">
								<b-field>
									<a class="button is-primary" @click="lock_all()">Vergrendelen</a>
								</b-field>
							</div>
							<div class="level-item">
								<b-field>
									<a class="button is-primary" @click="unlock_all()">Ontgrendelen</a>
								</b-field>
							</div>
						</div>
					</nav>
				</header>
				<div style="padding:5px;">
					<b-table
						:data="Users"
						:bordered="false"
						:narrowed="true"
						:striped="true"
						:loading="loading"
						:paginated="isPaginated"
						:per-page="perPage"
						:current-page.sync="currentPage"
						:pagination-simple="isPaginationSimple"
						:default-sort-direction="defaultSortDirection"
						default-sort="id"
					>
						<template slot-scope="props">
							<b-table-column width="40">
								<a class="button is-warning is-small" @click="handleClick(props.row.id)">
									<b-icon icon="pencil"></b-icon>
								</a>
							</b-table-column>
							<b-table-column field="id" label="ID">{{ props.row.id }}</b-table-column>
							<b-table-column field="tbl_school.name" label="School">
								<template v-if="props.row.tbl_school">{{ props.row.tbl_school.name }}</template>
							</b-table-column>

							<b-table-column
								field="tbl_school.schoolnumber"
								label="Schoolnr"
								centered
							>	<template v-if="props.row.tbl_school">{{ props.row.tbl_school.schoolnumber }}</template></b-table-column>
							<b-table-column field="displayname" label="Schermnaam">{{ props.row.displayname }}</b-table-column>
							<b-table-column field="tbl_school.username" label="Username">{{ props.row.username }}</b-table-column>
							<b-table-column label="Password">{{ props.row.password }}</b-table-column>
							<b-table-column label="Firstlogin" field="firstlogin" centered>
								<b-checkbox
									size="is-small"
									v-model="props.row.firstlogin"
									@change.native="flClick(props.row.id,(props.row.firstlogin? 1 : 0))"
								></b-checkbox>
							</b-table-column>
							<b-table-column label="Locked" field="locked_system" centered>
								<b-checkbox
									size="is-small"
									v-model="props.row.locked_system"
									@change.native="slClick(props.row.id,(props.row.locked_system ? 1 : 0))"
								></b-checkbox>
							</b-table-column>
							<b-table-column label="Roles">
								<b-select
									placeholder="Select a name"
									v-model="props.row.tbl_sys_userrol.role_id"
									size="is-small"
									@change.native="role_save(props.row.id,props.row.tbl_sys_userrol.role_id);"
								>
									<option v-for="option in Roles" :value="option.id" :key="option.id">{{ option.name }}</option>
								</b-select>
							</b-table-column>
						</template>
					</b-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import Axios from "axios";
import Cookies from "js-cookie";
import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "lock",

	data: function() {
		return {
			access: Cookies.get("access"),
			user: Cookies.getJSON("user"),
			Roles: [],
			Schools: [],
			selected_roles: [],
			selected_role: null,
			selected_firstlogin: [],
			boards: [],
			selected_locked: [],
			selected_school: null,
			Users: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 12
		};
	},
	created() {
		this.selected_school = 0;
		this.selected_role = 0;
		this.getSchools();
		this.getRoles();
	},
	watch: {
		selected_role: function(obj, value) {
			console.log("One of the selected role changed!");
			this.getUsers();
		},
		selected_school: function() {
			this.getUsers();
		}
	},
	computed: {},
	methods: {
		lock_all() {
			var self = this;
			console.log("lock all!!");
			for (let index = 0; index < this.Users.length; index++) {
				const element = this.Users[index];
				instance
					.post("/user/set-lockedsystem", {
						id: element.id,
						role_id: this.selected_role,
						locked_system: 1
					})
					.then(function(response) {
						self.getUsers();
					});
			}
		},
		unlock_all() {
			console.log("unlock all!!");
			var self = this;
			for (let index = 0; index < this.Users.length; index++) {
				const element = this.Users[index];
				instance
					.post("/user/set-lockedsystem", {
						id: element.id,
						rolei_id: this.selected_role,
						locked_system: 0
					})
					.then(function(response) {
						self.getUsers();
					});
			}
		},
		handleClick(id) {
			console.log("userid: " + id);
			console.log(this.user.data);
			this.$router.push({
				path: "/lock/update/" + id
			});
		},
		newUser() {
			this.$router.push({
				path: "/lock/new"
			});
		},
		flClick(id, value) {
			console.log(id);
			console.log(value);

			instance
				.post("/user/set-firstlogin", {
					id: id,
					firstlogin: value
				})
				.then(function(response) {
					//console.log(response.data.data);
				});
		},
		slClick(id, value) {
			console.log(id);
			console.log(value);
			instance
				.post("/user/set-lockedsystem", {
					id: id,
					locked_system: value
				})
				.then(function(response) {
					//console.log(response.data.data);
				});
		},
		role_save(id, value) {
			console.log(id);
			console.log(value);

			var self = this;
			this.$nextTick(function() {
				// DOM is now updated
				// `this` is bound to the current instance
				console.log(self.selected_roles);

				instance
					.post("/userrol-update", {
						user_id: id,
						role_id: value
					})
					.then(function(response) {
						//console.log(response.data.data);
					});
			});
		},
		getUsers: function() {
			var self = this;

			this.params = this.$route.params;
			console.log("Selected School");
			console.log(this.selected_school);
			console.log("Selected Firstlogin");
			console.log(this.selected_firstlogin);
			console.log("Selected Locked");
			console.log(this.selected_locked);
			console.log("Selected Roles");
			console.log(this.selected_roles);
			self.loading = true;

			self.selected_firstlogin = [];
			self.selected_locked = [];
			self.selected_roles = [];
			self.Users = [];
			if (self.selected_school === 0) {
				instance
					.get("/user", {
						params: {
							role_id: self.selected_role
						}
					})
					.then(function(response) {
						// var users = _.sortBy(response.data.data, [
						// 	function(o) {
						// 		return o.tbl_school.schoolnumber;
						// 	}
						// ]);
						self.Users = response.data.data;

						self.loading = false;
						console.log(self.selected_roles);
					});
			} else {
				instance
					.get("/user/school", {
						params: {
							id: self.selected_school,
							role_id: self.selected_role
						}
					})
					.then(function(response) {
						self.Users = response.data.data;

						// Vue.nextTick(function() {
						// alert(self.selected_roles);
						// });

						self.loading = false;
						console.log(self.selected_roles);
					});
			}
		},
		getRoles: function() {
			var self = this;

			//console.log(this.selected_class);
			this.params = this.$route.params;

			instance.get("/role").then(function(response) {
				console.log(response.data.data);
				console.log(self.Roles);
				var roles = _.sortBy(response.data.data, [
					function(o) {
						return o.id;
					}
				]);

				self.Roles = roles;

				self.selected_school = 0;
				//self.getUsers(value);
			});
		},
		getSchools: function() {
			var self = this;
			self.loading = true;
			instance.get("/school").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);
				console.log(self.Schools);

				var schools = _.remove(response.data.data, function(n) {
					return n.schoolnumber > 0;
				});
				schools = _.sortBy(schools, [
					function(o) {
						return o.schoolnumber;
					}
				]);
				self.Schools = schools;

				self.loading = false;
			});
		}
	}
};
</script>
<style>
</style>
